import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { DealAPI } from '@business/api/deal';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap, map } from 'rxjs/operators';
import { DealLostReasonId, DealLostReasonResponse } from '@business/entities/deal';
import { R } from '@core/utils/r';
export class DealLostReasonBloc extends BaseBloc {
  private readonly reasonRepo = new Repository<DealLostReasonResponse>({
    getItemId: item => item.id,
  });

  readonly reasons$ = this.reasonRepo.items$.pipe(map(items => R.sortBy(items, 'name')));
  readonly selectItem = this.reasonRepo.selectItem;

  onReset() {
    this.reasonRepo.reset();
  }

  fetchLostReasons = () => {
    return DealAPI.fetchLostReasons().pipe(this.reasonRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_general_error') }));
  };

  createLostReason = (name: string) => {
    return DealAPI.createLostReason(name).pipe(
      this.reasonRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_deal_lost_reason'),
      }),
    );
  };

  updateLostReason = (id: DealLostReasonId, name: string) => {
    return DealAPI.updateLostReason(id, name).pipe(
      this.reasonRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_deal_lost_reason'),
      }),
    );
  };

  deleteLostReason = (id: DealLostReasonId) => {
    return showDeleteConfirmation('Delete Lost Reason', 'Do you really want to remove this lost reason?').pipe(
      switchMap(() => DealAPI.deleteLostReason(id)),
      this.reasonRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_deal_lost_reason'),
      }),
    );
  };
}
